import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { NetworkService } from 'src/app/services/network.service';

@Component({
  selector: 'app-client-public-network',
  standalone: true,
  imports: [
            CommonModule,
            MatDialogModule,
            MatFormFieldModule,
            MatSelectModule,
            FormsModule,
            ReactiveFormsModule,
            CdkScrollable,
            MatButtonModule,
            MatTooltipModule, 
            MatCardModule, 
            MatInputModule, 
            MatCheckboxModule,
            TablerIconsModule,
            NgxSpinnerModule,
            MatPaginator,
            MatIconModule,
            MatTabsModule,
            MatTableModule,
            MatTooltipModule 
      ],
  templateUrl: './client-public-network.component.html',
  styleUrl: './client-public-network.component.scss'
})
export class ClientPublicNetworkComponent  implements OnInit {



  pageIndex: number;
  length: number;
  palabraClave: string = '';
  mired:any[]=[];
  idCliente : string | null;


  constructor(
      private spinner: NgxSpinnerService,
      private snackBar: MatSnackBar,
      private netWorkService: NetworkService,
      private route: ActivatedRoute,
    ) {}


     ngOnInit(): void {
      this.route.paramMap.subscribe(params => {

        this.idCliente = params.get('icliente');
          this.callData();    
      });
    }
      public getServerData(event:PageEvent){
        this.callData(event);
      }
      
    
      public callData(event?: PageEvent): void {
        const pageNum = event?.pageIndex ? event.pageIndex + 1 : 1;
        const pageSize = event?.pageSize ? event.pageSize : 12;
        this.spinner.show();
        this.netWorkService.getMyPublicNetwork(pageNum, pageSize, this.palabraClave, this.idCliente).subscribe({
          next: (response) => {
            this.spinner.hide();
            this.pageIndex = response.pageNum - 1;
            this.length = response.total;
            this.mired = response.list;
          },
          error: (err) => {
            this.spinner.hide();
            console.error('Error al cargar mi :', err);
          },
        });
      }
}
